const ccYearReducer = (state = '', action) => {
	switch(action.type){
	case 'CCYEARVALUE':
		return action.payload;
	default:
		return state;
	}
}

export default ccYearReducer;